import type { ReactElement } from 'react';
import { Link } from 'react-router-dom';

import { cn } from '@/lib/utils';

import arrowLeft from '../assets/arrow-left.svg';

interface AuthHeadingProps {
  title: string;
  description?: string;
  back?: { to: string; label: string };
}

function AuthHeading({ title, description, back }: AuthHeadingProps): ReactElement {
  return (
    <header
      className={cn(
        'vtwo:flex vtwo:flex-col vtwo:gap-3',
        back ? 'vtwo:text-left' : 'vtwo:text-center'
      )}
    >
      <div className="vtwo:flex vtwo:items-center vtwo:gap-2.5">
        {back && (
          <Link
            to={back.to}
            aria-label={back.label}
            className="vtwo:shrink-0 vtwo:rounded vtwo:outline-none vtwo:focus-visible:ring-2 vtwo:focus-visible:ring-auth-focus"
          >
            <img alt="" src={arrowLeft} />
          </Link>
        )}
        <h1 className="vtwo:flex-1 vtwo:text-[21px] vtwo:leading-[normal] vtwo:font-medium vtwo:text-auth-foreground">
          {title}
        </h1>
      </div>
      {description && (
        <p className="vtwo:text-sm vtwo:leading-[normal] vtwo:text-auth-muted">{description}</p>
      )}
    </header>
  );
}

export default AuthHeading;
